import React, { useState, useEffect } from 'react';
import { Eye, EyeOff } from 'lucide-react';

const EditUserModal = ({
  user,
  onSave,
  onClose,
  organizations,
  isAdmin,
  allowPasswordChange,
}) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [org, setOrg] = useState('');
  const [cel, setCel] = useState('');
  const [ident, setIdent] = useState('');
  const [rol, setRol] = useState('');
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (user) {
      setName(user.name);
      setEmail(user.email);
      setOrg(user.org);
      setCel(user.cel);
      setIdent(user.ident);
      setRol(user.rol);
    }
  }, [user]);

  // const validateForm = () => {
  //   const newErrors = {};

  //   if (!name.trim()) {
  //     newErrors.name = 'El nombre es requerido';
  //   } else if (name.length < 3) {
  //     newErrors.name = 'El nombre debe tener al menos 3 caracteres';
  //   }

  //   if (!email.trim()) {
  //     newErrors.email = 'El correo es requerido';
  //   } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
  //     newErrors.email = 'Ingrese un correo válido';
  //   }

  //   if (password && password.length < 6) {
  //     newErrors.password = 'La contraseña debe tener al menos 6 caracteres';
  //   }

  //   if (!org) {
  //     newErrors.org = 'La organización es requerida';
  //   }

  //   if (!cel.trim()) {
  //     newErrors.cel = 'El celular es requerido';
  //   } else if (!/^[0-9+\-\s()]{10,15}$/.test(cel)) {
  //     newErrors.cel = 'Ingrese un número de celular válido';
  //   }

  //   if (!ident.trim()) {
  //     newErrors.ident = 'La identificación es requerida';
  //   }

  //   if (!rol) {
  //     newErrors.rol = 'El rol es requerido';
  //   }

  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };

  const handleSubmit = e => {
    e.preventDefault();

    // if (!validateForm()) {
    //   return;
    // }

    setIsSubmitting(true);
    try {
      onSave({
        ...user,
        name,
        email,
        password: password || undefined,
        org,
        cel,
        ident,
        rol,
      });
    } catch (error) {
      alert(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <dialog id="edit_modal" className="modal">
      <div className="modal-box max-w-2xl">
        <h3 className="font-bold text-2xl mb-4 text-center text-primary">
          Editar Usuario
        </h3>
        <div className="divider"></div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="form-control">
              <label className="label">
                <span className="label-text font-semibold">
                  Nombre completo
                </span>
              </label>
              <input
                type="text"
                className={`input input-bordered w-full ${
                  errors.name ? 'input-error' : ''
                }`}
                value={name}
                onChange={e => {
                  setName(e.target.value);
                  if (errors.name) {
                    setErrors({ ...errors, name: '' });
                  }
                }}
                placeholder="Nombre del usuario"
              />
              {errors.name && (
                <label className="label">
                  <span className="label-text-alt text-error">
                    {errors.name}
                  </span>
                </label>
              )}
            </div>

            <div className="form-control">
              <label className="label">
                <span className="label-text font-semibold">
                  Correo electrónico
                </span>
              </label>
              <input
                type="email"
                className={`input input-bordered w-full ${
                  errors.email ? 'input-error' : ''
                }`}
                value={email}
                onChange={e => {
                  setEmail(e.target.value);
                  if (errors.email) {
                    setErrors({ ...errors, email: '' });
                  }
                }}
                placeholder="correo@ejemplo.com"
                readOnly
              />
              {errors.email && (
                <label className="label">
                  <span className="label-text-alt text-error">
                    {errors.email}
                  </span>
                </label>
              )}
            </div>
          </div>

          {allowPasswordChange && (
            <div className="form-control">
              <label className="label">
                <span className="label-text font-semibold">Contraseña</span>
              </label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  className={`input input-bordered w-full pr-12 ${
                    errors.password ? 'input-error' : ''
                  }`}
                  value={password}
                  onChange={e => {
                    setPassword(e.target.value);
                    if (errors.password) {
                      setErrors({ ...errors, password: '' });
                    }
                  }}
                  placeholder="Dejar en blanco para no cambiar"
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 px-3 flex items-center"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
              {errors.password && (
                <label className="label">
                  <span className="label-text-alt text-error">
                    {errors.password}
                  </span>
                </label>
              )}
            </div>
          )}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="form-control">
              <label className="label">
                <span className="label-text font-semibold">Celular</span>
              </label>
              <input
                type="text"
                className={`input input-bordered w-full ${
                  errors.cel ? 'input-error' : ''
                }`}
                value={cel}
                onChange={e => {
                  setCel(e.target.value);
                  if (errors.cel) {
                    setErrors({ ...errors, cel: '' });
                  }
                }}
                placeholder="+57 (000) 000-0000"
              />
              {errors.cel && (
                <label className="label">
                  <span className="label-text-alt text-error">
                    {errors.cel}
                  </span>
                </label>
              )}
            </div>

            <div className="form-control">
              <label className="label">
                <span className="label-text font-semibold">Identificación</span>
              </label>
              <input
                type="text"
                className={`input input-bordered w-full ${
                  errors.ident ? 'input-error' : ''
                }`}
                value={ident}
                onChange={e => {
                  setIdent(e.target.value);
                  if (errors.ident) {
                    setErrors({ ...errors, ident: '' });
                  }
                }}
                placeholder="Número de ID"
              />
              {errors.ident && (
                <label className="label">
                  <span className="label-text-alt text-error">
                    {errors.ident}
                  </span>
                </label>
              )}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="form-control">
              <label className="label">
                <span className="label-text font-semibold">Organización</span>
              </label>
              <select
                className={`select select-bordered w-full ${
                  errors.org ? 'select-error' : ''
                }`}
                value={org}
                onChange={e => {
                  setOrg(e.target.value);
                  if (errors.org) {
                    setErrors({ ...errors, org: '' });
                  }
                }}
              >
                <option value="" disabled>
                  Seleccione una organización
                </option>
                {organizations.map(org => (
                  <option key={org._id} value={org.name}>
                    {org.name}
                  </option>
                ))}
              </select>
              {errors.org && (
                <label className="label">
                  <span className="label-text-alt text-error">
                    {errors.org}
                  </span>
                </label>
              )}
            </div>

            <div className="form-control">
              <label className="label">
                <span className="label-text font-semibold">Rol</span>
              </label>
              <select
                className={`select select-bordered w-full ${
                  errors.rol ? 'select-error' : ''
                }`}
                value={rol}
                onChange={e => {
                  setRol(e.target.value);
                  if (errors.rol) {
                    setErrors({ ...errors, rol: '' });
                  }
                }}
              >
                <option value="" disabled>
                  Seleccione un rol
                </option>
                <option value="Admin">Administrador</option>
                <option value="User">Usuario</option>
              </select>
              {errors.rol && (
                <label className="label">
                  <span className="label-text-alt text-error">
                    {errors.rol}
                  </span>
                </label>
              )}
            </div>
          </div>

          <div className="flex justify-end space-x-3 mt-6">
            <button type="button" className="btn btn-ghost" onClick={onClose}>
              Cancelar
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <span className="loading loading-spinner"></span>
              ) : (
                'Guardar Cambios'
              )}
            </button>
          </div>
        </form>
      </div>
      <form method="dialog" className="modal-backdrop">
        <button onClick={onClose}>cerrar</button>
      </form>
    </dialog>
  );
};

export default EditUserModal;
